import { render, staticRenderFns } from "./IconPoiShopping.vue?vue&type=template&id=293eb656&"
import script from "./IconPoiShopping.vue?vue&type=script&lang=js&"
export * from "./IconPoiShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports